module.exports = __webpack_public_path__ + "img/img (3).ddf9b379.jpg";